import { InterpretationRule } from 'components/OrganisationDetails/interpretation-rules/types';
import { createAction } from 'store/utils';
import {
  DELETE_RULE_FROM_STATE,
  DELETE_RULE_REQUEST,
  ENABLE_DISABLE_RULE_REQUEST,
  GET_RULE_FOR_APPLICATION_CONNECTION_REQUEST,
  GET_RULES_FOR_APPLICATION_CONNECTION_REQUEST,
  PARSE_RULE_DONE,
  PARSE_RULE_REQUEST,
  SAVE_RULE_REQUEST,
  SET_RULE_STATE,
  SET_RULES_FOR_APPLICATION_CONNECTION,
  UPDATE_ENABLED_DISABLED_STATE,
  UPDATE_RULE_REQUEST,
} from './constants';
import {
  SaveRuleRequestAction,
  UpdateRuleRequestAction,
  GetRulesForApplicationConnectionRequestAction,
  GetRuleForApplicationConnectionRequestAction,
  EnableDisableRuleRequestAction,
  DeleteRuleRequestAction,
  SetRulesForApplicationConnectionAction,
  SetRuleStateAction,
  DeleteRuleFromStateAction,
  UpdatedEnabledStateAction,
  ParseRuleRequestAction,
  ParseRuleDoneAction,
} from './types';

export const saveRuleRequest = (
  applicationConnectionId: string,
  rule: InterpretationRule
): SaveRuleRequestAction =>
  createAction(SAVE_RULE_REQUEST, {
    applicationConnectionId,
    rule,
  });

export const updateRuleRequest = (
  applicationConnectionId: string,
  rule: InterpretationRule,
  ruleId: string
): UpdateRuleRequestAction =>
  createAction(UPDATE_RULE_REQUEST, {
    applicationConnectionId,
    rule,
    ruleId,
  });

export const getRulesForApplicationConnectionRequest = (
  applicationConnectionId: string
): GetRulesForApplicationConnectionRequestAction =>
  createAction(GET_RULES_FOR_APPLICATION_CONNECTION_REQUEST, {
    applicationConnectionId,
  });

export const getRuleForApplicationConnectionRequest = (
  applicationConnectionId: string,
  ruleId: string
): GetRuleForApplicationConnectionRequestAction =>
  createAction(GET_RULE_FOR_APPLICATION_CONNECTION_REQUEST, {
    applicationConnectionId,
    ruleId,
  });

export const enableDisableRuleRequest = (
  applicationConnectionId: string,
  ruleId: string,
  enabled: boolean
): EnableDisableRuleRequestAction =>
  createAction(ENABLE_DISABLE_RULE_REQUEST, {
    applicationConnectionId,
    ruleId,
    enabled,
  });

export const deleteRuleRequest = (
  applicationConnectionId: string,
  ruleId: string
): DeleteRuleRequestAction =>
  createAction(DELETE_RULE_REQUEST, {
    applicationConnectionId,
    ruleId,
  });

export const setRulesForApplicationConnection = (
  rules: InterpretationRule[],
  applicationConnectionId: string
): SetRulesForApplicationConnectionAction =>
  createAction(SET_RULES_FOR_APPLICATION_CONNECTION, {
    rules,
    applicationConnectionId,
  });

export const setRuleState = (
  rule: InterpretationRule,
  ruleId: string
): SetRuleStateAction =>
  createAction(SET_RULE_STATE, {
    rule,
    ruleId,
  });

export const deleteRuleFromState = (
  ruleId: string
): DeleteRuleFromStateAction =>
  createAction(DELETE_RULE_FROM_STATE, {
    ruleId,
  });

export const updateEnableDiabledState = (
  ruleId: string,
  enabled: boolean
): UpdatedEnabledStateAction =>
  createAction(UPDATE_ENABLED_DISABLED_STATE, {
    ruleId,
    enabled,
  });

export const parseRuleRequest = (
  sentence: string,
  tcNames: string[]
): ParseRuleRequestAction =>
  createAction(PARSE_RULE_REQUEST, {
    sentence,
    tcNames,
  });

export const parseRuleDone = (
  rule: InterpretationRule | null
): ParseRuleDoneAction => createAction(PARSE_RULE_DONE, { rule });